module.exports = __webpack_public_path__ + "static/045_third-landscape-4536557ec99b3218076a51599680e329.gif";